import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Loading from "components/Loading";
import "./LinkedinImportStatus.scss";

const LinkedinImportStatus = () => {
  const { t } = useTranslation("profile");
  const location = useLocation();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    const urlParams = new URLSearchParams(location.search);
    const urlStatus = urlParams.get("status");

    if (urlStatus === "error") {
      setStatus("error");
    } else if (urlStatus === "success") {
      setStatus("success");
    }
  }, [location]);

  useEffect(() => {
    if (status !== "loading") {
      const timer = setTimeout(() => {
        window.close();
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [status]);

  const renderContent = () => {
    switch (status) {
      case "success":
        return (
          <>
            <div className="emoji">✅</div>
            <p>{t("profile:linkedin_import_success")}</p>
          </>
        );
      case "error":
        return (
          <>
            <div className="emoji">❌</div>
            <p>{t("profile:linkedin_import_error")}</p>
          </>
        );
      default:
        return (
          <>
            <Loading />
            <p className="my-4">{t("linkedin_import_loading")}</p>
          </>
        );
    }
  };

  return (
    <div className="linkedin-import-status">
      {renderContent()}
    </div>
  );
};

export default LinkedinImportStatus;
